import { TRootState } from "../../types"

export const getCategoriesSelector = (state: TRootState) => state.categories
